export default "__VITE_ASSET__bfnZC3kn__"